export function shortenAddress(address: string = '', length: number = 4) {
  return (
    address && `${address.substring(0, length + 2)}...${address.substring(address.length - length)}`
  );
}
